import React, { useMemo, useState } from 'react';
import Button from '../../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { createCin7WarehouseIntegration } from '../../../store/actions/integrations';
import SimpleInput from '../../common/SimpleInput/SimpleInput';
import { InfoTooltip } from '../../common/InfoTooltip';

import styles from '../ConnectForm.module.scss';

export function ConnectCin7Form() {
  const dispatch = useDispatch();
  const { submitting } = useSelector((state) => state.integrations);

  const [form, setForm] = useState({
    userEmail: '',
    apiKey: '',
    locations: '',
  });

  const onChange = (e) => {
    const { value, name } = e.target;
    setForm((form) => ({ ...form, [name]: value }));
  };

  const onSubmit = (e) => {
    dispatch(createCin7WarehouseIntegration(form));
    e.preventDefault();
  };

  const isDisabled = useMemo(() => {
    return submitting || form.userEmail === '' || form.apiKey === '' || form.locations === '';
  }, [submitting, form]);

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <div className={styles.body}>
        <label>
          User Email:
          <span className={styles.mandatory}>*</span>
        </label>
        <SimpleInput value={form.userEmail} onChange={onChange} name="userEmail" type="email" />

        <label>
          API key:
          <span className={styles.mandatory}>*</span>
          <InfoTooltip width={250} content={<p>Please obtain from your Cin7 account</p>} />
        </label>
        <SimpleInput value={form.apiKey} onChange={onChange} focus={false} name="apiKey" />

        <label>
          Locations:
          <span className={styles.mandatory}>*</span>
          <InfoTooltip
            width={300}
            content={
              <p>
                Please indicate the Cin7 location IDs from which to pull inventory (eg. <strong>123, 456</strong>)
              </p>
            }
          />
        </label>
        <SimpleInput value={form.locations} onChange={onChange} focus={false} name="locations" />
      </div>

      <div className={styles.footer}>
        <div className={styles.button}>
          <Button type="submit" text="Continue" loading={submitting} disabled={isDisabled} />
        </div>
      </div>
    </form>
  );
}
